import { styled, alpha } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';
import { colors } from '../../../../styles/theme';

// Container principal de la barra de progreso
export const ProgressBarContainer = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(2),
  padding: `${theme.spacing(1)} ${theme.spacing(2)}`,
  width: '100%',
}));

// Barra de fondo
export const ProgressBarTrack = styled(Box)(({ theme }) => ({
  height: '10px',
  width: '100%',
  backgroundColor:
    theme.palette.mode === 'dark' ? alpha(theme.palette.common.white, 0.12) : colors.grey[200],
  borderRadius: '10px',
  overflow: 'hidden',
  position: 'relative',
  boxShadow: 'inset 0 1px 3px rgba(0, 0, 0, 0.1)',
}));

// Barra de progreso activa
export const ProgressBarFill = styled(Box)(({ theme }) => ({
  height: '100%',
  background: 'linear-gradient(to right, #9333ea, #3b82f6, #10b981)',
  transition: 'all 0.5s ease-in-out',
  borderRadius: theme.spacing(1),
  position: 'relative',

  '&::after': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.2), transparent)',
    animation: 'shimmer 2s infinite',
  },

  '@keyframes shimmer': {
    '0%': {
      transform: 'translateX(-100%)',
    },
    '100%': {
      transform: 'translateX(100%)',
    },
  },
}));

// Container de información
export const ProgressInfoContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginTop: theme.spacing(0.5),
}));

// Texto de paso actual
export const StepText = styled(Typography)(({ theme }) => ({
  fontSize: '13px',
  color: theme.palette.text.secondary,
  fontWeight: 500,
  letterSpacing: '0.01em',
}));

// Texto de porcentaje
export const PercentageText = styled(Typography)(({ theme }) => ({
  fontSize: '13px',
  color: theme.palette.text.primary,
  fontWeight: 600,
  letterSpacing: '0.01em',
}));

// Variante para diferentes tamaños
export const ProgressBarContainerSmall = styled(ProgressBarContainer)(({ theme }) => ({
  padding: `${theme.spacing(0.5)} ${theme.spacing(1)}`,

  '& .MuiBox-root': {
    height: '6px',
  },
}));

export const ProgressBarContainerLarge = styled(ProgressBarContainer)(({ theme }) => ({
  padding: `${theme.spacing(2)} ${theme.spacing(3)}`,

  '& .MuiBox-root': {
    height: '12px',
  },
}));

// Variante para diferentes colores
export const ProgressBarFillSuccess = styled(ProgressBarFill)(({ theme }) => ({
  background: 'linear-gradient(to right, #10b981, #059669)',
}));

export const ProgressBarFillWarning = styled(ProgressBarFill)(({ theme }) => ({
  background: 'linear-gradient(to right, #f59e0b, #d97706)',
}));

export const ProgressBarFillError = styled(ProgressBarFill)(({ theme }) => ({
  background: 'linear-gradient(to right, #ef4444, #dc2626)',
}));
